var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusAguardando(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "status-aguardando",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.786,
    height: 16.311,
    viewBox: "0 0 16.786 16.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1457",
    "data-name": "Caminho 1457",
    d: "M45.844,39.471V39.3a.333.333,0,0,0-.667,0v.172a1.062,1.062,0,0,0-.866.782.982.982,0,0,0,.463,1.106,5.338,5.338,0,0,0,.5.255l.428.2a1.06,1.06,0,0,1,.3.243.346.346,0,0,1-.035.405.669.669,0,0,1-.726.16.454.454,0,0,1-.322-.52.333.333,0,0,0-.664-.059,1.121,1.121,0,0,0,.766,1.208,1.421,1.421,0,0,0,.153.039v.166a.333.333,0,0,0,.667,0v-.169a1.141,1.141,0,0,0,.683-.457,1.016,1.016,0,0,0,.033-1.144,1.646,1.646,0,0,0-.566-.473l-.432-.2a4.758,4.758,0,0,1-.45-.227.32.32,0,0,1-.159-.35c.033-.115.107-.386.734-.318a.429.429,0,0,1,.309.138.509.509,0,0,1,.07.343.333.333,0,0,0,.656.117,1.173,1.173,0,0,0-.191-.857A1.039,1.039,0,0,0,45.844,39.471Z",
    transform: "translate(-32.593 -28.956)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1458",
    "data-name": "Caminho 1458",
    d: "M26.854,8.229a.4.4,0,1,0-.8,0V8.91a.4.4,0,0,0,.8,0Z",
    transform: "translate(-19.246 -6.119)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1459",
    "data-name": "Caminho 1459",
    d: "M26.454,43.507a.4.4,0,0,0-.4.4v.681a.4.4,0,1,0,.8,0v-.681A.4.4,0,0,0,26.454,43.507Z",
    transform: "translate(-19.246 -32.283)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1460",
    "data-name": "Caminho 1460",
    d: "M43.015,26.946a.4.4,0,1,0,0,.8H43.7a.4.4,0,0,0,0-.8Z",
    transform: "translate(-31.391 -20.138)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1461",
    "data-name": "Caminho 1461",
    d: "M7.338,26.946a.4.4,0,1,0,0,.8h.681a.4.4,0,0,0,0-.8Z",
    transform: "translate(-5.228 -20.138)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1462",
    "data-name": "Caminho 1462",
    d: "M21.385,17.7a.4.4,0,0,0-.8,0v2.172H19a.4.4,0,1,0,0,.8h1.988a.4.4,0,0,0,.4-.4c0-.013,0-.025,0-.038a.362.362,0,0,0,0-.038Z",
    transform: "translate(-13.778 -13.063)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1463",
    "data-name": "Caminho 1463",
    d: "M38.229,33.454a3.884,3.884,0,1,0,3.884,3.884A3.888,3.888,0,0,0,38.229,33.454Zm0,6.968a3.084,3.084,0,1,1,3.084-3.084A3.087,3.087,0,0,1,38.229,40.422Z",
    transform: "translate(-25.326 -24.911)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1464",
    "data-name": "Caminho 1464",
    d: "M7.731,15.03a6.438,6.438,0,1,1,6.363-5.683,4.515,4.515,0,0,1,.785.187,7.235,7.235,0,1,0-5.621,6.127A4.509,4.509,0,0,1,9,14.9a6.449,6.449,0,0,1-1.274.13Z",
    transform: "translate(-0.524 -1.415)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAguardando);
export default __webpack_public_path__ + "static/media/status-aguardando.b0fcac651f3207a2d211599fd83d446b.svg";
export { ForwardRef as ReactComponent };